import { render, staticRenderFns } from "./BulkQuizForm.vue?vue&type=template&id=9f1127ca"
import script from "./BulkQuizForm.vue?vue&type=script&lang=js"
export * from "./BulkQuizForm.vue?vue&type=script&lang=js"
import style0 from "./BulkQuizForm.vue?vue&type=style&index=0&id=9f1127ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports